import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense, type CSSProperties } from "react";
import { Toaster } from "@nexus/ui";

export interface RouterContext {
  queryClient: QueryClient;
}

const showDevtools =
  import.meta.env.MODE !== "production" &&
  import.meta.env.VITE_DEVTOOLS !== "false";

const QueryDevtools = showDevtools
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((m) => ({
        default: m.ReactQueryDevtools,
      })),
    )
  : () => null;

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const { queryClient } = Route.useRouteContext();

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="bottom-left" style={{ "--width": "480px" } as CSSProperties} />
      <Outlet />
      <Suspense>
        <QueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      </Suspense>
    </QueryClientProvider>
  );
}
